import React from 'react'
import styles from './assignModal.module.css';
import { Close, Deletemodal } from '../../../Svg';
import { Paper, Typography, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const AssignModal = ({ isOpen, onClose, onAssign, heading, admin, name, setAdmin, selectedAdmin }) => {
    const StyledGrid = styled(Grid)(({ theme }) => ({
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderRadius: theme.shape.borderRadius,
    }));

    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <button onClick={onClose} className={styles.closeButton}>  <Close onClick={onClose} /></button>
                <div className={styles.modalContentDetails}>
                    <div className={styles.modalHeader}>
                        <h2>{heading} assign </h2>
                    </div>
                    <Paper sx={{ p: 2, mb: 2, boxShadow: '0px 4px 4px 0px #00000026', }}>
                        <StyledGrid container>
                            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
                                <img src="/assets/profile.png" />
                                <Typography sx={{ fontSize: "14px", color: '#1D1F2C', padding: '5px' }}>
                                    {name}
                                </Typography>
                            </Grid>
                        </StyledGrid >
                    </Paper>

                    <label className={styles.addCatLabel}>
                        Admin
                        <select className={styles.addCatSelect} value={selectedAdmin} onChange={(e) => {
                            setAdmin(e.target.value);
                        }}>
                            <option value="" >Select...</option>
                            {admin?.map((row) => (

                                <option value={row?._id}>{row?.name}</option>
                            ))

                            }

                        </select>
                    </label>
                    <div className={styles.modalFooter}>
                        <button onClick={onClose} className={styles.cancelButton} >Cancel</button>
                        <button onClick={onAssign} className={styles.deleteButton}>assign</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AssignModal;
